import React from 'react';

function getSeasonImage(locale) {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // Les mois sont indexés à partir de 0
    const day = currentDate.getDate();
    let imageName = '';

    if (
        (month === 3 && day >= 16) ||
        (month >= 3 && month <= 11) ||
        (month === 11 && day <= 15)
    ) {
        imageName = 'Automn';
    } else if (
        (month === 11 && day >= 16) ||
        (month < 3) ||
        (month === 3 && day < 15)
    ) {
        imageName = 'Winter';
    } else {
        imageName = 'Summer';
    }

    if (locale === 'fr' || locale === 'en') {
        imageName += `-${locale}`;
    }

    return (
        <img src={require(`./Images/${imageName}.jpg`)} alt="Image accueil" />
    );
}

export default getSeasonImage;